export const preliminaryPlan = ['Green space', 'Urban Agr./Homesteading', 'Small Business', 'Housing', 'Rental property'];
